export const EDUCATION = 'education';
export const PERSONAL = 'personal';
export const WORK = 'work';

export const ALL = [WORK, PERSONAL, EDUCATION];
